import Cookies from "js-cookie"

import cuckoo from "common/services/cuckoo/cuckoo"
import { parseQuery } from "common/services/query/queries"
import * as utm from "../../../../app/scripts/tools/utm"

const setAffiliate = () => {
  if (typeof window.SP_GLOBALS.SKYPICKER_AFFILIATE !== "undefined") {
    Cookies.set("SKYPICKER_AFFILIATE", window.SP_GLOBALS.SKYPICKER_AFFILIATE, {
      ...Skypicker.cookieOptions,
      expires: window.SP_GLOBALS.SKYPICKER_AFFILIATE.split("_")[0] === "aviasales" ? 365 : 30,
    })
  }
}

const setAffiliateSub = () => {
  if (typeof window.SP_GLOBALS.SKYPICKER_AFFILIATE_SUB !== "undefined") {
    Cookies.set("SKYPICKER_AFFILIATE_SUB", window.SP_GLOBALS.SKYPICKER_AFFILIATE_SUB, {
      ...window.Skypicker.cookieOptions,
      expires: 30,
    })
  }
}

const setAffiliateUid = () => {
  if (typeof window.SP_GLOBALS.SKYPICKER_AFFILIATE_UID !== "undefined") {
    Cookies.set("SKYPICKER_AFFILIATE_UID", window.SP_GLOBALS.SKYPICKER_AFFILIATE_UID, {
      ...window.Skypicker.cookieOptions,
      expires: 30,
    })
  }
}

const initAffiliates = () => {
  // Synchronize Forter cookie to all subdomains, so it's send to API
  const forterToken = Cookies.get("forterToken")
  // affilid for following partners
  const affilid = window.getEnvParameter("affilid")

  if (forterToken) {
    Cookies.set("forterTokenCopy", forterToken, Skypicker.cookieOptions)
  }

  // Main Affiliate cookie
  // ===
  setAffiliate()
  setAffiliateSub()
  setAffiliateUid()

  // Kayak
  // FIXME: cmp2 should be tracked the same as kayak but clickid is not present
  // isSubAffilId(affilid, "cmp2")
  // ===
  let kayakClickId = window.getEnvParameter("clickid")
  if (kayakClickId) {
    if (navigator.cookieEnabled) {
      // Requested by Kayak to escape `web-` & `mobile-` prefixes from clickId
      // "web-FKCUevTjrZbFS5IisfHz3w" => "FKCUevTjrZbFS5IisfHz3w"
      kayakClickId = kayakClickId.replace("web-", "").replace("mobile-", "")

      window.sessionStorage.setItem("kayakClickId", kayakClickId)
    } else {
      // ignore
    }
  }

  // TradeDoubler
  // ===
  const tradeDoublerUid = window.getEnvParameter("tduid")
  if (typeof tradeDoublerUid !== "undefined") {
    Cookies.set("tradeDoublerUid", tradeDoublerUid, {
      ...window.Skypicker.cookieOptions,
      expires: 30,
    })
  }

  // Express Revenue
  const expressRevenueSubID = window.getEnvParameter("postback")
  if (typeof expressRevenueSubID !== "undefined" && affilid.indexOf("er_") === 0) {
    Cookies.set("expressRevenueSubId", expressRevenueSubID, {
      ...window.Skypicker.cookieOptions,
      expires: 30,
    })
  }

  // sub1 passed for more partners
  // ===
  const sub1Param = window.getEnvParameter("sub1")
  if (typeof sub1Param !== "undefined") {
    Cookies.set("sub1Param", sub1Param, { ...window.Skypicker.cookieOptions, expires: 30 })
  }

  // gclid passed for more partners
  // ===
  const gclidParam = window.getEnvParameter("gclid")
  if (typeof gclidParam !== "undefined") {
    Cookies.set("google_click_id", gclidParam, { ...window.Skypicker.cookieOptions, expires: 30 })
  }

  // UTM params
  // ===
  utm.saveToSession(cuckoo, parseQuery(document.location.search))

  // GWM params - now testing FE pixels
  // ===
  const gwmSourcePage = window.getEnvParameter("source_page")
  if (typeof gwmSourcePage !== "undefined" && gwmSourcePage === "flatcpa") {
    Cookies.set("gwmSourcePage", gwmSourcePage, { ...window.Skypicker.cookieOptions, expires: 30 })
  }
}

export default initAffiliates
